export const GET_USER_NOTIFICATION_PERMISSION_REQUEST = "GET_USER_NOTIFICATION_PERMISSION_REQUEST";
export const GET_USER_NOTIFICATION_PERMISSION_SUCCESS = "GET_USER_NOTIFICATION_PERMISSION_SUCCESS";
export const GET_USER_NOTIFICATION_PERMISSION_FAILURE = "GET_USER_NOTIFICATION_PERMISSION_FAILURE";

export const getUserNotificationPermissionRequest = () => ({
    type: GET_USER_NOTIFICATION_PERMISSION_REQUEST,
});

export const getUserNotificationPermissionSuccess = (permission) => ({
    type: GET_USER_NOTIFICATION_PERMISSION_SUCCESS,
    payload: { permission },
});

export const getUserNotificationPermissionFailure = (error) => ({
    type: GET_USER_NOTIFICATION_PERMISSION_FAILURE,
    payload: { error },
});
